<template>
    <div class="c-m-empty-state">
        <div class="c-m-empty-state__inner">
            <icon v-if="icon" :icon="icon" />
            <p v-if="heading" class="c-m-empty-state__heading h2">{{heading}}</p>
            <div v-if="body" class="c-m-empty-state__body" v-html="body"></div>
        </div>
    </div>
</template>
<script>
    import Icon from '../atoms/AtomIcon.vue';

    export default {
        props: [
            'heading',
            'body',
            'icon'
        ],
        props: {
            heading: {
                type: String,
                default: 'Här var det tomt!'
            },
            body: {
                type: String,
                default: '<p>Det finns inga resultat att visa</p>'
            },
            icon: {
                type: String,
                default: 'sentiment_neutral'
            }
        },
        components: {
            Icon
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeEmptyState.vue